import { Enum } from '@lighthouse/tools'

import type {
    AnchorProtocol,
    Arrangement,
    BaseBreakPointProtocol,
    BlockSize,
    CursorProtocol,
    IndependentAction,
    RichTextContentProtocol
} from '../../protocols'
import type { EventsProtocol } from '../../protocols/event'
import type { IconDecorationProtocol } from '../../protocols/icon'
import { BlockType } from '../Basic'
import { BaseBlock } from './BaseBlock'

export interface CardBlockItemConfig extends EventsProtocol {
    id: string
    iconDecoration?: IconDecorationProtocol
    iconColor: string
    heading?: RichTextContentProtocol
    introduction?: RichTextContentProtocol
}

export const CARD_STYLE = Enum('default', 'block', 'card')
export type CardStyle = Enum<typeof CARD_STYLE>

export interface CardBlockConfig extends BaseBreakPointProtocol, AnchorProtocol {
    layout?: Arrangement
    cols?: number
    style?: CardStyle
    size?: BlockSize
    direction: 'vertical' | 'horizontal'
    list: CardBlockItemConfig[]

    cursor?: CursorProtocol
}

export abstract class CardBlockAbstract extends BaseBlock {
    type = BlockType.card

    abstract override config: CardBlockConfig
}
